export default __webpack_public_path__ + "static/media/01.88b981df.jpg";